import { MdAdd, MdCheck } from "react-icons/md";

interface LessonOptionsCardProps {
  text: string;
  selected: boolean;
  onClickFunction: () => void;
}

const LessonOptionsCard: React.FC<LessonOptionsCardProps> = ({
  text,
  selected,
  onClickFunction,
}) => {
  return (
    <div
      className={`group self-stretch p-3 bg-neutral-25 hover:bg-neutral-50 ease-in-out duration-150 ${
        selected ? "border-success-600" : "border-transparent"
      } border rounded-xl inline-flex justify-start items-center gap-3 cursor-pointer`}
      onClick={onClickFunction}
    >
      <div className="flex-1 justify-start text-neutral-700 text-sm font-semibold font-sans leading-none">
        {text}
      </div>
      <div
        className={`p-2 ${
          selected
            ? "bg-success-600 group-hover:bg-success-700"
            : "bg-neutral-100 group-hover:bg-neutral-200"
        } ease-in-out duration-150 rounded-full flex justify-start items-start gap-2`}
      >
        {selected ? (
          <MdCheck className="w-4 h-4 fill-neutral-50" />
        ) : (
          <MdAdd className="w-4 h-4 fill-neutral-500" />
        )}
      </div>
    </div>
  );
};

export default LessonOptionsCard;
